import { Search, X } from 'lucide-react';
import { useRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'type'> {
  value: string;
  onChange: (value: string) => void;
  label: string;
}

export function SearchInput({ value, onChange, label, className, placeholder, ...rest }: SearchInputProps) {
  const ref = useRef<HTMLInputElement>(null);
  return (
    <div className={cn('relative', className)}>
      <Search aria-hidden="true" size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink-muted" />
      <input
        ref={ref}
        type="search"
        aria-label={label}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && value) {
            e.stopPropagation();
            onChange('');
          }
        }}
        className="control h-control pl-9 pr-9 [&::-webkit-search-cancel-button]:hidden"
        {...rest}
      />
      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={() => {
            onChange('');
            ref.current?.focus();
          }}
          className="absolute right-2 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded text-ink-muted hover:bg-surface-sunken hover:text-ink focus-visible:shadow-focus focus-visible:outline-none"
        >
          <X size={14} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
